// extracted by mini-css-extract-plugin
module.exports = {"submit-button-container":"imei_submit-button-container__FJJR7","form__item--min-length":"imei_form__item--min-length__V41X8","tab--no-overflow":"imei_tab--no-overflow__eTP2s"};